import { inject } from '@angular/core';
import { EventsService, FilterEventsCommand, LargeScaleEventFilterType } from 'src/app/boxwood-api';
import { totalOf } from 'src/app/shared/dashboard-grid';

/** Every incident, open or closed; large-scale parents and children both count, as on the Incidents page. */
export const ALL_INCIDENTS: FilterEventsCommand = { largeScaleEventFilter: LargeScaleEventFilterType.None };

/** Boxwood's `events/active` would also count incidents closed in the last 24 hours. */
export const OPEN_INCIDENTS: FilterEventsCommand = {
  ...ALL_INCIDENTS,
  advancedSearch: {
    searches: [{ notOneOf: [{ field: 'incidentEventStatus.incidentEventState.name', values: ['Closed'] }] }],
  },
};

export const INCIDENT_CREATED_FIELD = 'created.timestamp';

export const INCIDENTS_ROUTE = '/incidents-v2/list';

export function incidentRoute(id: string): string[] {
  return ['/incidents-v2', id];
}

export function injectIncidentCount(): (command: FilterEventsCommand, abortSignal: AbortSignal) => Promise<number> {
  const events = inject(EventsService);
  return (command, abortSignal) =>
    totalOf(events.filterEventsCommand({ page: 1, pageSize: 1, uNKNOWNBASETYPE: command }), abortSignal);
}
